import { ModalLogin } from '@/auth'
import {
  CMSFooter,
  CmsSiteHeader,
  OverviewDescription,
  SearchResultsBlock,
  YfSocial,
  ShareBar,
  NewsletterSubscription,
  CmsSearchBar,
  CmsInternalMenu
} from '@/cmsPage'
import { ToastContainer } from '@/notifications'
import { ShareContainer } from '@/share'

import defineBundle from './_defineBundle'

// exported for using in functional tests
export const exposedComponents = {
  'toast-container': ToastContainer,
  footer: CMSFooter,
  'login-container': ModalLogin,
  'site-header': CmsSiteHeader,
  'overview-description': OverviewDescription,
  'search-block': SearchResultsBlock,
  social: YfSocial,
  'share-bar': ShareBar,
  'share-container': ShareContainer,
  'newsletter-subscription': NewsletterSubscription,
  'search-bar': CmsSearchBar,
  'internal-menu': CmsInternalMenu
}

const preloadedComponents = [
]

defineBundle(exposedComponents, preloadedComponents)
